import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';

import {getParam} from '../utils/utils';
import {formatText, truncate} from '../utils/utils';
import {cloneObject} from '../utils/utils';

import Buffering from "../components/Buffering"; 

import dsd from "../classes/clsDSD";

import {getInterface, addParameterToInterface, editParameter, deleteParameter, getParameter} from "../utils/utilsInterface";

import D3Graphviz from "../components/D3Graphviz";
import ViewParameter from "../components/ViewParameter";
import ViewInterface from "../components/ViewInterface";

import ViewMetadata from "../components/ViewMetadata";

import Revision from "../components/Revision";
import ListRevisions from "../components/ListRevisions";

import Rendition from '../components/Rendition';

import { Plus, Trash, ArrowUp, ArrowDown } from 'react-bootstrap-icons';


import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

class Parameter extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: null
        };


        this.data = {};
        this.viz = null;
        this.vizEngine = "dot";


        this.handleChange = this.handleChange.bind(this);
        this.handleControls = this.handleControls.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);

        this.refRevision = React.createRef();
        this.loadedRevisions = this.loadedRevisions.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/`;

    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadInterface(id){

        this.setState({renderState: "loading"});

        const onLoad = (Interface) => {
            this.FallBackNavigation = `/interface/${Interface._id}`;

            let StateChange = {
                Interface: Interface,
                idInterface: Interface._id,
                renderState: "loaded"
            };

            if (this.state.mode === 'new'){
                StateChange.FormData = {
                    status: 'in use'
                };
            }

            StateChange.OfferEdit = false;
            if (this.dsd.loggedon){
                if (this.dsd.user.id === Interface.idUser){
                    StateChange.OfferEdit = true;
                }
            }

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "new":
                    case "edit":
                    case "delete":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot add or edit Parameters to this Interface";
                        break;
                }
            }

            this.setState(StateChange);
        };

        const onFail = (e) => {
            this.setState({
                renderState: "failed",
                errorMessage: e.message
            });
        };

        getInterface(this.dsd, id, onLoad, onFail);
        
    };

    loadParameter(id){

        this.setState({renderState: "loading"});

        const onLoad = (Parameter) => {
            this.FallBackNavigation = `/interface/${Parameter.Interface._id}`;

            let StateChange = {
                Interface: Parameter.Interface,
                idInterface: Parameter.Interface._id,
                Parameter: Parameter,
                FormData: Parameter,
                renderState: "loaded"
            };

            if (Parameter.Interface){
                if (this.context.hasLayout){
                    this.context.Layout.setLeftAsInterface(Parameter.Interface._id);
                }
            }

            StateChange.OfferEdit = false;
            if (this.dsd.loggedon){
                if (this.dsd.user.id === Parameter.Interface.idUser){
                    StateChange.OfferEdit = true;
                }
            }

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "new":
                    case "edit":
                    case "delete":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot add or edit Parameters to this Interface";
                        break;
                }
            }

            this.setState(StateChange);
        };

        const onFail = (e) => {
            this.setState({
                renderState: "failed",
                errorMessage: e.message
            });
        };

        getParameter(this.dsd, id, onLoad, onFail);
        
    };


    setup(){

        let StateChange = {

            mode: "view",

            toggle : 0,

            idParameter: null,
            idInterface: null,

            Interface: null,
            Parameter: null,

            renderState: null,

            FormData: {},
            OfferEdit:false,

            Controls: {
            },

            countRevisions: null

        }

        if (getParam('mode', this.props)){
            StateChange.mode = getParam('mode', this.props);
        }
        StateChange.idParameter = getParam('id', this.props);
        StateChange.idInterface = getParam('idInterface', this.props);

        switch (StateChange.mode){
            case 'new':
                if (!StateChange.idInterface){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Interface not specified when adding a Parameter"
                }
                break;
            default:
                if (StateChange.idInterface){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Interface should not be specified for an existing Parameter"
                }
                if (!StateChange.idParameter){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Parameter not specified"
                }
                break;
        }

        if (StateChange.mode == "new"){
            if (StateChange.idInterface){
                this.FallBackNavigation = `/interface/${StateChange.idInterface}`;
            }        
        }

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        this.setState(StateChange);

        // Direct orchestration
        if (StateChange.idInterface && StateChange.mode === 'new'){
            this.loadInterface(StateChange.idInterface);
        }

        if (StateChange.idParameter){
            this.loadParameter(StateChange.idParameter);
        }
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;        
                this.setState({"FormData": FormData});
                break;                
        }
        return;

    };
    
    handleControls(event){

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let Controls = this.state.Controls;
        Controls[FormFieldName] = FormFieldValue;        
        this.setState({"Controls": Controls});

        return;

    }


    handleSubmit(event) {

        const onAdd = (idParameter) => {
            this.props.navigation(`/parameter/${idParameter}`);
        };

        const onUpdate = (Parameter) => {
            this.refRevision.current.update();
            this.props.navigation(`/parameter/${this.state.idParameter}`);

        };

        const onDelete = () => {
            this.props.navigation(this.FallBackNavigation);
        };

        const onError = (error) => {
            this.setState({
                renderState: error.status,
                errorMessage: error.errorMessage
            });
        };

        window.scrollTo(0, 0);

        switch (event.target.name){
            
            case 'btnCancel':

                switch (this.state.mode){
                    case "edit":
                    case "delete":
                        this.props.navigation(`/parameter/${this.state.idParameter}`);
                        break;
                    case "new":
                        this.props.navigation(this.FallBackNavigation);
                        break;
                }

                break;
            case 'btnDelete':
                this.setState({renderState: "updating"});
                deleteParameter(this.dsd, this.state.idInterface, this.state.idParameter, onDelete, onError);
                break;
            case 'btnSave':
            default:

                this.setState({renderState: "updating"});
        
                switch (this.state.mode){
                    case 'new':
                        addParameterToInterface(this.dsd, this.state.idInterface, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        editParameter(this.dsd, this.state.idParameter, this.state.FormData, onUpdate, onError);
                        break;
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
        }

        this.setState(StateChange);

        event.preventDefault();
    };


    handleVizClick(event) {

        let idNode = null;
        if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }
        
        if (idNode){
            let partsVizNodeId = idNode.split('_');
            switch(partsVizNodeId[0]){
                case 'structure':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/structure/${partsVizNodeId[1]}`);
                    }
                    break;
            }
        }

        event.preventDefault();

    };


    loadedRevisions(count) {

        let StateChange = {};

        StateChange.countRevisions = 0;
        if (count){
            StateChange.countRevisions = count;
        }

        this.setState(StateChange);


    };


    visualise(){
    
        if (!this.state.Parameter){
            return null;
        }



        try {

            return(
                <div>

                    <div name="divViz" onClick={this.handleVizClick}>
                        <D3Graphviz dot={this.viz.dot}/>
                    </div>

                </div>
            );
          } catch (error) {
            return <div/>
          }
    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
    
        }


        switch (this.state.mode){
            case 'new':
            case 'edit':

                switch (this.state.renderState){
                    case "loaded":
                    case "updating":
                    case "error":

                        return (
                            <div>

                                <PD.Heading>{this.state.mode} Parameter</PD.Heading>

                                {this.state.renderState == "error" &&
                                    <PD.ErrorBox>{this.showError()}</PD.ErrorBox>
                                }

                                <form> 
                                    <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                                    <PD.Editor label='Description' name="description" value={this.state.FormData.description} onChange={this.handleChange}/>
                                    <PD.Editor label='Proposals' name="proposals" value={this.state.FormData.proposals} onChange={this.handleChange}/>

                                    <PD.Select label='Data Type' name='dataType'  onChange={this.handleChange} value={this.state.FormData.dataType}>
                                        {
                                            Object.keys(this.dsd.model.config.ParameterDataTypes).map(
                                                (datatype, pos) => 
                                                    {
                                                        return(
                                                            <option key={pos} value={datatype}>{datatype}</option>
                                                        )
                                                    }
                                            )
                                        }
                                    </PD.Select>

                                    {this.state.FormData.dataType == 'lookup' &&
                                        this.FormValues()
                                    }

                                    <Revision ref={this.refRevision}  idAbout={this.state.idParameter}/>
                                    
                                    {(() => {
                                        switch (this.state.renderState) {
                                            case "updating":
                                                return (
                                                    <div>
                                                        <PD.Button disabled={true} type="submit" name="btnSave">
                                                            <Buffering/>
                                                        </PD.Button>
                                                    </div>
                                                )
                                            default:
                                                return (
                                                    <div>
                                                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave" value="Save" />    
                                                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" /> 
                                                    </div>
                                                )
                                        }
                                    })()}

                                </form>

                            </div>    
                        );
                }
                break;
            case 'delete':
                return (
                    <div>
                        <PD.Heading>{this.state.mode} Parameter</PD.Heading>

                        {this.state.isFailed &&
                            <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                        }

                        <PD.Button name="btnDelete" onClick={this.handleSubmit} type="warning" value="confirm delete?" />
                        <PD.Button name="btnCancel" onClick={this.handleSubmit} type="warning" value="cancel" />
                        <ViewParameter Parameter={this.state.Parameter}/>

                    </div>
                )
            case 'view':
            default:
                
                switch (this.state.renderState){
                    case "loaded":

                        return (
                            <div>
                                <div>
                                    <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                    <PD.Heading>Parameter:{this.state.Parameter.name}</PD.Heading>
                                </div>

                                {this.state.OfferEdit &&
                                    <span style={{paddingRight:10}}>
                                            <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                            <PD.Button onClick={this.handleMode} type="submit" value="delete" />
                                    </span>
                                }

                                <ViewParameter Parameter={this.state.Parameter}/>

                                <br/>

                                <PD.Tabs>

                                    <div label='Interface'>
                                        <ViewInterface Interface={this.state.Interface}/>
                                    </div>


                                    <div label={<span>Revisions({this.state.countRevisions === null ? <Buffering/> : this.state.countRevisions})</span>} data-forcerender="true">
                                        <ListRevisions OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idParameter}} onLoad={this.loadedRevisions}/>
                                    </div>

                                    <div label='Developer'>
                                        <Rendition
                                            endpoint="/parameters"
                                            id={this.state.idParameter}
                                        />
                                    </div>


                                </PD.Tabs>


                            </div>
                        )
                }
        };

        return <div />;
    };

    showError(){

        return(
            <>
                {this.state.errorMessage &&
                    <p>{this.state.errorMessage}</p>
                }

                {this.state.invalidFields &&
                    Object.keys(this.state.invalidFields).map(
                    (field, pos) => 
                        {
                            let error = this.state.invalidFields[field].error;
                            return <p key={pos}>{field}:{error}</p>
                        }
                    )
                }
            </>
        )

    }


    FormValues(){

        let seqNext = 1;
        if (this.state.FormData.values){
            seqNext = this.state.FormData.values.length + 1;
        }
        return (
            <fieldset key={this.state.toggle}>
                <legend>Permitted Values</legend>
                {this.state.FormData.values &&
                    this.state.FormData.values.map(
                        (value, posValue) => 
                        {
                            let seq = posValue+1;
                            return(
                                this.FormValue('edit', seq, value)
                            )
                        }
                    )
                }
                {this.FormValue('new', seqNext)}
            </fieldset>
        );

    }

    FormValue(mode, seq, value = ''){
        let onChange = function(event){

            const value = event.target.value;

            let FormData = {...this.state.FormData};
            FormData.Values = [...(FormData.Values || [])];
            FormData.Values[seq-1] = value;

            this.setState({"FormData": FormData});

            return;
        }
        onChange = onChange.bind(this);

        let onAdd = function(event){

            let FormData = {...this.state.FormData};
            FormData.values = [...(FormData.values || []), ''];
  
            this.setState({"FormData": FormData, "toggle": !this.state.toggle});

            event.preventDefault();
            return;
        }
        onAdd = onAdd.bind(this);


        let onDelete = function(event){

            let FormData = {...this.state.FormData};
            FormData.values = [...(FormData.values || [])];
            FormData.values.splice(seq-1, 1);
      
            this.setState({"FormData": FormData, "toggle": !this.state.toggle});
    
            event.preventDefault();
            return;
        }
        onDelete = onDelete.bind(this);

        let onMoveUp = null;
        let onMoveDown = null;


        if (this.state.FormData.values){
            if (seq < this.state.FormData.values.length){
                onMoveDown = function(event){

                    let FormData = {...this.state.FormData};
                    FormData.values = [...(FormData.values || [])];
      
       // Swap with next item
                    [FormData.values[seq-1], FormData.values[seq]] =
                    [FormData.values[seq], FormData.values[seq-1]];
      
                    this.setState({"FormData": FormData, "toggle": !this.state.toggle});

                    event.preventDefault();
                    return;

                }
                onMoveDown = onMoveDown.bind(this);

            }


            if ((seq > 1) && (seq<=this.state.FormData.values.length)){
                onMoveUp = function(event){

                    let FormData = {...this.state.FormData};
                    FormData.values = [...(FormData.values || [])];
  
   // Swap with previous item
                   [FormData.values[seq-2], FormData.values[seq-1]] =
                   [FormData.values[seq-1], FormData.values[seq-2]];
  
                    this.setState({"FormData": FormData, "toggle": !this.state.toggle});

                    event.preventDefault();
                    return;
        
                }
                onMoveUp = onMoveUp.bind(this);
            }
        }


        return(

            <PD.Table type="list">
                <PD.Tbody>
                    <PD.Tr>
                        <PD.Td>
                            {(() => {
                                switch (mode) {
                                    case "new": 
                                        return <button name="btnAdd" onClick={onAdd}><Plus/></button>;
                                    case "edit": 
                                        return <button name="btnDelete" onClick={onDelete}><Trash/></button>;
                                }
                            })()}
                            {onMoveUp &&
                                <div>
                                    <button name="btnUp" onClick={onMoveUp}><ArrowUp/></button>
                                </div>
                            }
                            {onMoveDown &&
                                <div>
                                    <button name="btnDown" onClick={onMoveDown}><ArrowDown/></button>
                                </div>
                            }
                            
                        </PD.Td>
                        {mode == 'edit' &&
                            <React.Fragment>
                                <PD.Td>
                                    <PD.Input key={seq} label="Value" width="40" name="value" value={value} onBlur={onChange}/>
                                </PD.Td>
                            </React.Fragment>
                        }
                    </PD.Tr>
                </PD.Tbody>
            </PD.Table>
        )
    }
    
};

// Wrap and export
export default function Parameter_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Parameter {...props} navigation={navigation} location={location} params={params} />;
  }